<template>
    <div class="record-grid container-fluid">
        <div class="row no-gutters">
            <record-item
                v-for="item in mapsList"
                :record="item"
                :service="service"
                :key="item.identifier"
                :authkeyParamNames="authkeyParamNames"
                :catalogURL="catalogURL"
                :catalogType="catalogType"
                :map="map"
                :crs="crs"
                :hideThumbnail="hideThumbnail"
                :hideExpand="hideExpand"
                :hideIdentifier="hideIdentifier"
                :layerBaseConfig="layerBaseConfig"
                :showGetCapLinks="showGetCapLinks"
                :source="source"
                :zoomToLayer="zoomToLayer"
                :layers="layers"
                :showTemplate="showTemplate"
                :defaultFormat="defaultFormat"
                :formatOptions="formatOptions"
                :infoFormatOptions="infoFormatOptions"
                @onLayerAdd="onLayerAdd"
                @onError="onError" />
        </div>
    </div>
</template>

<script>
    import RecordItem from './CatalogRecordItem';

    export default {
        name: 'CatalogRecordGrid',
        components: {
            RecordItem,
        },
        props: {
            column: {
                type: String,
                default: 'col-xs-12',
            },
            addAuthentication: {
                type: Boolean,
            },
            authkeyParamNames: {
                type: Array,
            },
            catalogURL: {
                type: String,
            },
            catalogType: {
                type: String,
            },
            map: {
                type: Object,
                default: null,
            },
            crs: {
                type: String,
                default: 'EPSG:3857',
            },
            currentLocale: {
                type: String,
                default: 'en-US',
            },
            hideThumbnail: {
                type: Boolean,
                default: false,
            },
            hideExpand: {
                type: Boolean,
                default: false,
            },
            hideIdentifier: {
                type: Boolean,
                default: false,
            },
            layerBaseConfig: {
                type: Object,
                default: () => {},
            },
            records: {
                type: Array,
                required: true,
                default: () => [],
            },
            showGetCapLinks: {
                type: Boolean,
                default: false,
            },
            zoomToLayer: {
                type: Boolean,
                default: true,
            },
            layers: {
                type: Array,
                default: () => [],
            },
            source: {
                type: String,
            },
            service: {
                type: Object,
                default: () => {},
            },
            showTemplate: {
                type: Boolean,
                default: false,
            },
            defaultFormat: {
                type: String,
                default: 'image/png',
            },
            formatOptions: {
                type: Array,
                default: () => [],
            },
            infoFormatOptions: {
                type: Array,
                default: () => [],
            },
            modalParams: {
                type: Object,
                default: () => {},
            },
        },
        computed: {
            mapsList() {
                return this.records instanceof Array ? this.records : [this.records];
            },
        },
        methods: {
            onLayerAdd(layer, options){
                this.$emit('onLayerAdd', layer, options);
            },
            onError(error){
                this.$emit('onError', error);
            }
        }

    }

</script>

<style scoped lang="scss">

</style>